import CoreEngineering_0 from "../assets/images/Placement/Companies/Core Engineering/25-nissan.jpg";
import CoreEngineering_1 from "../assets/images/Placement/Companies/Core Engineering/25-Payoda.png";
import CoreEngineering_2 from "../assets/images/Placement/Companies/Core Engineering/26-sirius.png";
import CoreEngineering_3 from "../assets/images/Placement/Companies/Core Engineering/27-Vernalis.jpg";
import CoreEngineering_4 from "../assets/images/Placement/Companies/Core Engineering/29-anristu.webp";
import CoreEngineering_5 from "../assets/images/Placement/Companies/Core Engineering/30-kalycito.png";
import CoreEngineering_6 from "../assets/images/Placement/Companies/Core Engineering/31-fanuc.jpg";
import CoreEngineering_7 from "../assets/images/Placement/Companies/Core Engineering/31-odessa.jfif";
import CoreEngineering_8 from "../assets/images/Placement/Companies/Core Engineering/31-urc.svg";
import CoreEngineering_9 from "../assets/images/Placement/Companies/Core Engineering/34-vuram.png";
import CoreEngineering_10 from "../assets/images/Placement/Companies/Core Engineering/35-rane.jpg";
import CoreEngineering_11 from "../assets/images/Placement/Companies/Core Engineering/36-sakthi.png";
import CoreEngineering_12 from "../assets/images/Placement/Companies/Core Engineering/37-brakes.png";
import CoreEngineering_13 from "../assets/images/Placement/Companies/Core Engineering/38-delphi.png";
import CoreEngineering_14 from "../assets/images/Placement/Companies/Core Engineering/39-kbr.png";
import CoreEngineering_15 from "../assets/images/Placement/Companies/Core Engineering/40-airlight.png";
import CoreEngineering_16 from "../assets/images/Placement/Companies/Core Engineering/41-Trimble.png";
import CoreEngineering_17 from "../assets/images/Placement/Companies/Core Engineering/42-pentafox.png";
import CoreEngineering_18 from "../assets/images/Placement/Companies/Core Engineering/43-josh.jpg";
import CoreEngineering_19 from "../assets/images/Placement/Companies/Core Engineering/44-Rapid_Data.png";
import ITSoftware_0 from "../assets/images/Placement/Companies/IT & Software/1-cts.jpg";
import ITSoftware_1 from "../assets/images/Placement/Companies/IT & Software/10-tcs.webp";
import ITSoftware_2 from "../assets/images/Placement/Companies/IT & Software/12-tvs.jpg";
import ITSoftware_3 from "../assets/images/Placement/Companies/IT & Software/13-Tech_Mahindra.png";
import ITSoftware_4 from "../assets/images/Placement/Companies/IT & Software/14-Britannia.png";
import ITSoftware_5 from "../assets/images/Placement/Companies/IT & Software/15-itc.png";
import ITSoftware_6 from "../assets/images/Placement/Companies/IT & Software/16-Bosch.png";
import ITSoftware_7 from "../assets/images/Placement/Companies/IT & Software/17-Polaris.png";
import ITSoftware_8 from "../assets/images/Placement/Companies/IT & Software/18-Soliton.png";
import ITSoftware_9 from "../assets/images/Placement/Companies/IT & Software/19-Hyundai.png";
import ITSoftware_10 from "../assets/images/Placement/Companies/IT & Software/2-wipro.png";
import ITSoftware_11 from "../assets/images/Placement/Companies/IT & Software/20-sanmar.png";
import ITSoftware_12 from "../assets/images/Placement/Companies/IT & Software/21-LarsenToubro.png";
import ITSoftware_13 from "../assets/images/Placement/Companies/IT & Software/22-hatsun.jpg";
import ITSoftware_14 from "../assets/images/Placement/Companies/IT & Software/23-Vedanta.jpg";
import ITSoftware_15 from "../assets/images/Placement/Companies/IT & Software/24-icici.avif";
import ITSoftware_16 from "../assets/images/Placement/Companies/IT & Software/3-infosys.jpg";
import ITSoftware_17 from "../assets/images/Placement/Companies/IT & Software/4-accenture.jpg";
import ITSoftware_18 from "../assets/images/Placement/Companies/IT & Software/5-zoho.png";
import ITSoftware_19 from "../assets/images/Placement/Companies/IT & Software/6-Huawei-Logo.png";
import ITSoftware_20 from "../assets/images/Placement/Companies/IT & Software/7-newge.png";
import ITSoftware_21 from "../assets/images/Placement/Companies/IT & Software/8-Mu-sigma.png";
import ITSoftware_22 from "../assets/images/Placement/Companies/IT & Software/9-ELGi.png";
import Management_0 from "../assets/images/Placement/Companies/Management/45-blubridge.jpeg";
import Management_1 from "../assets/images/Placement/Companies/Management/46-valeo.png";
import Management_2 from "../assets/images/Placement/Companies/Management/47-Bi3-Logo.png";
import Management_3 from "../assets/images/Placement/Companies/Management/48-CDW Sirius.png";
import Management_4 from "../assets/images/Placement/Companies/Management/49-codemagen_logo.jpeg";
import Management_5 from "../assets/images/Placement/Companies/Management/50-jman.jpeg";
import Management_6 from "../assets/images/Placement/Companies/Management/51.Securin.svg";
import Management_7 from "../assets/images/Placement/Companies/Management/52-Likan.avif";
import Management_8 from "../assets/images/Placement/Companies/Management/53-Rubrik.png";
import Management_9 from "../assets/images/Placement/Companies/Management/Adrasti logo (1).jpeg";
import Management_10 from "../assets/images/Placement/Companies/Management/coreEL Technologies logo..jpeg";
import Management_11 from "../assets/images/Placement/Companies/Management/Endava Solutions logo.png";
import Management_12 from "../assets/images/Placement/Companies/Management/ERP Roots Logo (1).jpeg";
import Management_13 from "../assets/images/Placement/Companies/Management/Green Collar Agritech Solutions Pvt. Ltd. Logo.png";
import Management_14 from "../assets/images/Placement/Companies/Management/hitech calibration logo.jpeg";
import Management_15 from "../assets/images/Placement/Companies/Management/IamNeo.ai logo.png";
import Management_16 from "../assets/images/Placement/Companies/Management/Ignitarium logo.png";
import Management_17 from "../assets/images/Placement/Companies/Management/J&F India Pvt. Ltd..jpeg";
import Management_18 from "../assets/images/Placement/Companies/Management/JPMorgan Chase (1).png";
import Management_19 from "../assets/images/Placement/Companies/Management/nbase2 logo (1).png";
import Management_20 from "../assets/images/Placement/Companies/Management/Openmynz - Logo.png";
import Management_21 from "../assets/images/Placement/Companies/Management/Presidio logo.jpeg";
import Management_22 from "../assets/images/Placement/Companies/Management/Radiant global technology logo.png";
import Management_23 from "../assets/images/Placement/Companies/Management/Schneider Electric Logo (1).jpeg";
import Startups_0 from "../assets/images/Placement/Companies/Startups/SKM Groups logo.jpg";
import Startups_1 from "../assets/images/Placement/Companies/Startups/SRC Projects.jpeg";
import Startups_2 from "../assets/images/Placement/Companies/Startups/WhatsApp Image 2025-09-15 at 11.27.31 AM.jpeg";
import Startups_3 from "../assets/images/Placement/Companies/Startups/WhatsApp Image 2025-09-15 at 11.28.18 AM.jpeg";
import Startups_4 from "../assets/images/Placement/Companies/Startups/WhatsApp Image 2025-09-15 at 11.35.49 AM.jpeg";
import Startups_5 from "../assets/images/Placement/Companies/Startups/WhatsApp Image 2025-09-15 at 11.45.14 AM.jpeg";
import Startups_6 from "../assets/images/Placement/Companies/Startups/WhatsApp Image 2025-09-15 at 11.45.57 AM.jpeg";
import Startups_7 from "../assets/images/Placement/Companies/Startups/WhatsApp Image 2025-09-15 at 11.55.18 AM.jpeg";
import Startups_8 from "../assets/images/Placement/Companies/Startups/WhatsApp Image 2025-09-16 at 1.43.24 PM.jpeg";
import Startups_9 from "../assets/images/Placement/Companies/Startups/WhatsApp Image 2025-09-16 at 1.43.48 PM.jpeg";
import Startups_10 from "../assets/images/Placement/Companies/Startups/WhatsApp Image 2025-09-16 at 2.21.06 PM.jpeg";
import Startups_11 from "../assets/images/Placement/Companies/Startups/WhatsApp Image 2025-10-09 at 11.26.43 AM.jpeg";
import Startups_12 from "../assets/images/Placement/Companies/Startups/WhatsApp Image 2025-10-09 at 11.42.54 AM.jpeg";
import Startups_13 from "../assets/images/Placement/Companies/Startups/workhall logo.png";

export const companyImages = {
  "Core Engineering": [
    CoreEngineering_0,
    CoreEngineering_1,
    CoreEngineering_2,
    CoreEngineering_3,
    CoreEngineering_4,
    CoreEngineering_5,
    CoreEngineering_6,
    CoreEngineering_7,
    CoreEngineering_8,
    CoreEngineering_9,
    CoreEngineering_10,
    CoreEngineering_11,
    CoreEngineering_12,
    CoreEngineering_13,
    CoreEngineering_14,
    CoreEngineering_15,
    CoreEngineering_16,
    CoreEngineering_17,
    CoreEngineering_18,
    CoreEngineering_19,
  ],
  "IT & Software": [
    ITSoftware_0,
    ITSoftware_1,
    ITSoftware_2,
    ITSoftware_3,
    ITSoftware_4,
    ITSoftware_5,
    ITSoftware_6,
    ITSoftware_7,
    ITSoftware_8,
    ITSoftware_9,
    ITSoftware_10,
    ITSoftware_11,
    ITSoftware_12,
    ITSoftware_13,
    ITSoftware_14,
    ITSoftware_15,
    ITSoftware_16,
    ITSoftware_17,
    ITSoftware_18,
    ITSoftware_19,
    ITSoftware_20,
    ITSoftware_21,
    ITSoftware_22,
  ],
  "Management": [
    Management_0,
    Management_1,
    Management_2,
    Management_3,
    Management_4,
    Management_5,
    Management_6,
    Management_7,
    Management_8,
    Management_9,
    Management_10,
    Management_11,
    Management_12,
    Management_13,
    Management_14,
    Management_15,
    Management_16,
    Management_17,
    Management_18,
    Management_19,
    Management_20,
    Management_21,
    Management_22,
    Management_23,
  ],
  "Startups": [
    Startups_0,
    Startups_1,
    Startups_2,
    Startups_3,
    Startups_4,
    Startups_5,
    Startups_6,
    Startups_7,
    Startups_8,
    Startups_9,
    Startups_10,
    Startups_11,
    Startups_12,
    Startups_13,
  ],
};
